
import {Later} from 'utils/timers'

const TIMEOUT = 60

export default {
  props: {
    question: {type: Object, required: true}
  },
  emits: ['answer-ai'],
  data() {
    return {
      remaining: 0,
      timer: new Later(1000),
      enabled: true
    }
  },
  watch: {
    enabled() {
      this.resetTimer()
    },
  },
  mounted() {
    this.resetTimer()
  },
  beforeUnmount() {
    this.stopTimer()
  },
  methods: {
    disableTimer(){
      this.enabled = false
    },
    resetTimer() {
      this.stopTimer()
      this.remaining = TIMEOUT
      if (!this.enabled) return
      this.startTimer()
    },
    startTimer() {
      this.timer.repeat(this.tick)
    },
    stopTimer() {
      this.timer.abort()
    },
    tick() {
      this.remaining -= 1
      if (this.remaining > 0) return
      this.$emit('answer-ai')
    }
  }
}
